import React from 'react'
import IconButton from '@mui/material/IconButton'
import InfoIcon from '@mui/icons-material/Info'
import Fade from '@mui/material/Fade'
import TealToolTip from 'components/TealToolTip'
import { pushEvent } from 'services/AnalyticsService'

const InfoHelperButton = ({ searchHelperVisible, setSearchHelperVisible, inputRef }) => {
  const handleOnClick = (e) => {
    inputRef.current.focus()
    pushEvent({
      category: 'Search',
      action: 'Click',
      label: 'Helper Icon'
    })
    setSearchHelperVisible(!searchHelperVisible)
  }

  return (
    <Fade in={!searchHelperVisible} timeout={500}>
      <span>
        <TealToolTip title='View Search Tips' placement='bottom' enterDelay={800} arrow={false} bgColor='dark'>
          <IconButton
            size='small'
            className='absolute right2 top-50 y--50'
            onClick={handleOnClick}
            data-testid='search-tips-icon'
          >
            <InfoIcon className='fill-medium-bluish-grey hover-fill-light-slate-grey' />
          </IconButton>
        </TealToolTip>
      </span>
    </Fade>
  )
}

export default InfoHelperButton
